import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { inject, observer } from 'mobx-react';
import styled from '@emotion/styled';
import * as DataList from 'components/DataList';
import InvoiceEditor from 'components/DocEditor/InvoiceEditor';
import { DocSkeleton } from 'components/DocEditor/DocSkeleton';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

// An invoice (/dashboard/invoices/:id/show): components/DocEditor.
@inject('invoiceStore', 'viewStore') @observer
class InvoiceShowPage extends Component {

  retry = () => {
    const uuid = window.location.pathname.split('/').filter(Boolean).slice(-2)[0];
    this.props.invoiceStore.getInvoice({ uuid });
  };

  // An invoice that doesn't exist (deleted, or a wrong link) gets a way back;
  // anything else (offline, server error) gets Try again.
  renderError() {
    const { invoiceStore: { invoice }, viewStore } = this.props;
    const missing = invoice.errorStatus === 404 || invoice.errorStatus === 403;
    const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const back = { label: 'Back to invoices', icon: 'arrow-left', onClick: () => viewStore.invoices() };
    return (
      <div className="cp-error">
        {missing ? (
          <DataList.Notice
            icon="dollar"
            title="This invoice isn't here"
            message="It may have been deleted, or the link may be wrong. Find it in your invoices instead."
            actions={[{ ...back, primary: true }]}
          />
        ) : (
          <DataList.Notice
            tone="error"
            icon={offline ? 'offline' : 'error'}
            role="alert"
            title="The invoice couldn't be loaded"
            message={offline ? "You're offline. Reconnect, then try again." : 'Something went wrong on our side. Try again in a moment.'}
            actions={[{ label: 'Try again', icon: 'refresh', onClick: this.retry, primary: true }, back]}
          />
        )}
      </div>
    );
  }

  render() {
    const { invoiceStore: { invoice: { isLoading, isError, object, errorStatus } } } = this.props;
    let content;
    let title;
    // Once shown, the invoice stays on screen while it saves or reloads.
    if (object && object.id && object.attributes) {
      title = `${object.attributes.number} invoice | Field Nexus`;
      content = <InvoiceEditor key={object.id} />;
    } else if (isError && !isLoading) {
      title = `${errorStatus === 404 ? 'Invoice not found' : "Couldn't load invoice"} | Field Nexus`;
      content = this.renderError();
    } else {
      title = 'Loading..';
      content = <DocSkeleton noun="invoice" />;
    }
    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <PageWrapGray>
          {content}
        </PageWrapGray>
      </div>
    );
  }
}

export default InvoiceShowPage;
